import { createRoot } from 'react-dom/client'
import 'leaflet/dist/leaflet.css'
import './index.css'
import ResizeObserverPolyfill from 'resize-observer-polyfill'
import App from './App'

if (typeof window !== 'undefined' && window.ResizeObserver == null) {
  window.ResizeObserver = ResizeObserverPolyfill
}

const rootElement = document.getElementById('root')

if (rootElement == null) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(<App />)
